import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteUpdate, getUpdates, resetState } from "../features/update/UpdateSlice";
import CustomModal from "../components/CustomModal";
import send from "../../utils/43_Send_notification-512.webp"
import { base_url } from "../../utils/baseUrl";
import { toast } from "react-toastify";


const columns = [
  {
    title: "SNo",
    dataIndex: "key",
    width: "25px",
    align: "center"
  },
  {
    title: "Title",
    dataIndex: "title",
    align: "center"
  },
  {
    title: "Content",
    dataIndex: "content",
    align: "center",
    render: (text, record) => (
      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {record.truncatedContent}
      </div>
    )
  },
  {
    title: "Action",
    dataIndex: "action",
    align: "center"
  },
];

const Associationlist = () => {
  const [open, setOpen] = useState(false);
  const [associationId, setAssociationId] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const dispatch = useDispatch();
  const token = useSelector((state) => state.autht.token);
  const circulars = useSelector((state) => state.update.Updates);

  useEffect(() => {
    dispatch(resetState());
    dispatch(getUpdates(token));
  }, []);

  const showModal = (id) => {
    setOpen(true);
    setAssociationId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const deleteNews = (id) => {
    dispatch(deleteUpdate(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getUpdates(token));
    }, 100);
  };



  const handleSendNotification = (title) => {
    const requestData = {
      title: "New Update please see in you Association",
      body: title
    };
    
    // Make a request to the backend API to send a notification
    // You can use fetch or any HTTP client library (e.g., axios) to make the request
    fetch(`${base_url}members/sendNotification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Include the JWT token in the headers
      },
      body: JSON.stringify(requestData)
    })
      .then(response => {
        if (response.ok) {
          // Notification sent successfully
  
          toast.success("Notification sent successfully");
          
          // Optionally, you can update the UI or show a success message
        } else {
        
          toast.error("Failed to send notification");
        }
      })
      .catch(error => {

        console.error('Error sending notification:', error);
        toast.error("Error sending notification");
        // Optionally, you can display an error message to the user
      });
  };


  const data1 = circulars.map((item, index) => ({
    key: index + 1,
    title: item.title,
    content: item.content,
    truncatedContent: item.content.substring(0, 100) + '...',
    action: (
      <>
        <Link to={`/association/Add-Circular/${item._id}`} className=" fs-3 text-danger">
          <BiEdit />
        </Link>
        <button className="ms-3 fs-3 text-danger bg-transparent border-0" onClick={() => showModal(item._id)}>
          <AiFillDelete />
        </button>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => handleSendNotification(item.title)}
          loading={loading}
        >
          <img height="15px" width="15px" src={send} alt="send" />
        </button>
      </>
    ),
  }));

  return (
    <div>
      <h3 className="mb-4 title">Updates List</h3>
      <div>
        <Table columns={columns} dataSource={data1} pagination={false} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(associationId);
        }}
        title="Are you sure you want to delete this Association?"
      />
      {toastMessage && (
        <div className="toast">
          <p>{toastMessage}</p>
        </div>
      )}
    </div>
  );
};

export default Associationlist;
